import { Survey } from '../components/Prescription/PrescriptionJob';
import Field from '../model/Field';

export const getSurveysForSelectedFields = (
  allSurveys: Survey[],
  bulkPrescriptionFields: Field[],
  isInBulkPrescriptionOverview: boolean,
  selectedFieldId: number | string
): Survey[] => {
  if (bulkPrescriptionFields.length > 0) {
    const surveysForBulkPrescriptionFields: Survey[] = [];

    bulkPrescriptionFields.map((field: Field) => {
      const surveyForField = allSurveys.find((survey) => field.fieldId === survey.fieldId);
      if (surveyForField) {
        surveysForBulkPrescriptionFields.push(surveyForField);
      }
    });

    return surveysForBulkPrescriptionFields;
  }

  const surveyForSelectedField: Survey | null = allSurveys.find(
    (survey) => survey.fieldId === selectedFieldId
  );
  if (surveyForSelectedField) {
    return [surveyForSelectedField];
  } else {
    return [];
  }
};
